import { configureStore } from "@reduxjs/toolkit";
import leaveTypesReducer from "../features/leaveTypes/leaveTypeSlice";
import leaveRequestsReducer from "../features/leaveRequests/leaveRequestSlice";
import usersReducer from "../features/users/userSlice";

export const store = configureStore({
  reducer: {
    leaveTypes: leaveTypesReducer,
    leaveRequests: leaveRequestsReducer,
    users: usersReducer,
  },
});

// TypeScript types for better inference
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
